import React from 'react';
import { createComponent } from '@ycos/fela';
import PropTypes from 'prop-types';

const propTypes = {
    count: PropTypes.number,
    align: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    containerClassName: PropTypes.string,
    additionalStyle: PropTypes.object,
};

const defaultProps = {
    count: 1,
};

const Skeleton = ({ additionalStyle, align, children, className, containerClassName, count }) => (
        <div className={containerClassName}>
            {new Array(count).fill(0, 0, count).map((value, index) => (
                <Item key={index} additionalStyle={additionalStyle} align={align} className={className} />
            ))}
            {children}
        </div>
    );

Skeleton.propTypes = propTypes;
Skeleton.defaultProps = defaultProps;

const shimmer = (spacingMultiplier) => ({
    '0%': {
        'background-position': `${-50 * spacingMultiplier}px 0`,
    },
    '100%': {
        'background-position': `${50 * spacingMultiplier}px 0`,
    },
});

const Item = createComponent('SkeletonItem', ({ additionalStyle, align, theme }) => ({
    height: `${2 * theme.spacingMultiplier}px`,
    backgroundColor: theme.skeleton.color,
    backgroundImage: 'linear-gradient(100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80%)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: `${50 * theme.spacingMultiplier}px ${14 * theme.spacingMultiplier}px`,
    animationName: shimmer(theme.spacingMultiplier),
    animationDuration: `${theme?.motionSpecs?.motionDurations?.t6}ms`,
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    animationFillMode: 'forwards',
    margin: `0 0 ${2 * theme.spacingMultiplier}px`,
    width: '100%',
    ...(align === 'left'
        ? {
              ':nth-of-type(3n + 1)': {
                  width: '80%',
              },
              ':nth-of-type(3n + 2)': {
                  width: '30%',
              },
              ':nth-of-type(3n + 3)': {
                  width: '50%',
              },
          }
        : {}),
    ...additionalStyle,
}));

export default Skeleton;
